import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getUrlLanguage } from "./urlLanguage";

// NOTE: ?lng= wins so the first render and the first API calls (x-lang) already use it
const storedLanguage =
  getUrlLanguage() || localStorage.getItem("i18nextLng") || "nl";

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    supportedLngs: ["en", "nl", "fr"],
    lng: storedLanguage,
    fallbackLng: "nl",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "em",
        "b",
        "p",
        "span",
        "div",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "ul",
        "ol",
        "li",
        "a",
        "img",
        "table",
        "thead",
        "tbody",
        "tr",
        "td",
        "th",
        "blockquote",
        "code",
        "pre",
        "hr",
        "u",
        "s",
        "strike",
        "sub",
        "sup",
        "small",
        "mark",
        "del",
        "ins",
      ],
    },
  });

export default i18n;

export const normalizeLanguage = (language) => {
  return language.split("-")[0].toLowerCase();
};
